<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="pkid > 0 ? '编辑' : '新建'"
      width="1300px"
      @close="$reset('form')">
    <el-form
        ref="form"
        :disabled="disabled"
        :model="deliveryNotice"
        :rules="ruleValidate"
        label-width="100px">
      <div class="vm-separate">
        <el-form-item label="发货通知单号">
          <el-input v-model="deliveryNotice.billNo" readonly/>
        </el-form-item>
        <!--        <el-form-item label="销售订单编号">-->
        <!--          <el-input v-model="deliveryNotice.salesOrderNo" readonly>-->
        <!--            <el-button slot="append" icon="el-icon-search" @click="$refs.salesOrderDetailSelect.open()"/>-->
        <!--          </el-input>-->

        <!--        </el-form-item>-->
        <el-form-item label="客户名称">
          <el-input v-model="deliveryNotice.customerName" readonly/>
        </el-form-item>
        <el-form-item label="发货日期" prop="deliveryDate">
          <el-date-picker
              v-model="deliveryNotice.deliveryDate"
              type="date"
              style="width: 320px;"
              value-format="yyyy-MM-dd"/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="发货地址" prop="deliveryAddress">
          <el-input
              v-model="deliveryNotice.deliveryAddress"
              placeholder="请选择详细地址"
              :disabled="!deliveryNotice.customerId">
            <el-button
                slot="append"
                icon="el-icon-search"
                :disabled="!deliveryNotice.customerId"
                @click="$refs.addressSelect.open(deliveryNotice.customerId)"/>
          </el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="deliveryNotice.deliveryContact"/>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="deliveryNotice.deliveryTel"/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="备注">
          <el-input v-model="deliveryNotice.deliveryNote1" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </div>
      <div style="margin-bottom:5px;text-align: right;margin-right: 10px;">
        <el-button type="primary" @click="$refs.salesOrderDetailSelect.open()">添加</el-button>
      </div>
      <el-table :data="deliveryNotice.deliveryBillDetails" border stripe height="40vh">
        <el-table-column label="销售订单" prop="salesOrderNO" align="center" width="100"/>
        <el-table-column label="物料编号" prop="materialNo" align="center" width="100"/>
        <el-table-column label="物料名称" prop="materialName" align="center" width="100"/>
        <!--        <el-table-column label="规格型号" prop="materialSpecification" align="center" width="200"/>-->
        <el-table-column label="订单数量" prop="salesOrderQuantity" align="center" width="100"/>
        <el-table-column label="已发数量" prop="shippedQuantity" align="center" width="80"/>
        <el-table-column label="客户型号" prop="customerSpecification" align="center" width="100">
          <template v-slot="scope">
            <el-input v-model="scope.row.customerSpecification" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column label="发货数量" prop="quantity" align="center" width="100">
          <template v-slot="scope">
            <el-input
                v-model="scope.row.quantity"
                placeholder="请输入"
                @change="quantityChange(scope.row, $event, scope.$index)"/>
          </template>
        </el-table-column>
        <el-table-column label="要求交期" prop="requireDeliveryDate" align="center" width="100"/>
        <el-table-column label="备注" prop="note" align="center" width="200">
          <template v-slot="scope">
            <el-input v-model="scope.row.note" type="textarea" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column label="订单备注" prop="orderRowNote" align="center" width="180"/>
        <el-table-column label="操作" align="center" width="80">
          <template v-slot="scope">
            <el-button type="danger" @click="deleteRow(scope.row,scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <material-select ref="materialSelect" @select="addMaterial"/>
    <sales-order-detail-select ref="salesOrderDetailSelect" @select="salesOrderDetailSelect"/>
    <address-select ref="addressSelect" @select="addressSelect"/>
    <div slot="footer">
      <el-button @click="closePage">取消</el-button>
      <el-button v-if="!disabled" type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import SalesOrderDetailSelect from "@/views/SalesManage/SalesOrder/SalesOrderDetailMutiSelect";
  import AddressSelect from "@/views/information/Customer/CustomerAddressSelect";

  export default {
    components: {MaterialSelect, SalesOrderDetailSelect, AddressSelect},

    data() {
      return {
        dialogVisible: false,
        pkid: 0,
        disabled: false,
        selectedMaterial: "",
        materials: [],
        materialOptions: [],
        deliveryNotice: {
          totalAmount: "",
          billNo: "",
          salesOrderNo: "",
          customerName: "",
          deliveryDate: "",
          deliveryAddress: "",
          deliveryContact: "",
          deliveryTel: "",
          deliveryNote1: "",
          deliveryBillDetails: [],
        },
        ruleValidate: {
          deliveryDate: {required: true, message: "请选择发货日期", trigger: "change"},
        },
      };
    },
    computed: {
      totalPrice() {
        var sum = 0;
        this.deliveryNotice.deliveryBillDetails.forEach((item) => {
          sum += item.quantity * item.price;
        });
        return sum.toFixed(2);
      },
    },
    methods: {
      open(id, disabled, orderDetails) {
        this.dialogVisible = true;
        this.disabled = disabled;
        if (id > 0) {
          this.pkid = id;
          this.getData();
        } else if (id === 0) {
          this.getDeliveryNo();
          this.salesOrderDetailSelect(orderDetails);
        } else {
          this.getDeliveryNo();
        }
      },

      getDeliveryNo() {
        this.$http.get("basic", "sd/DeliveryBills/selectDeliveryBillNo").then(res => {
          if (res.success) {
            this.deliveryNotice.billNo = res.data;
          }
        });
      },

      // 选择详细地址
      addressSelect(row) {
        this.deliveryNotice.deliveryContact = row.contact;
        this.deliveryNotice.deliveryTel = row.telephone;
        this.deliveryNotice.deliveryAddress = row.districtName + row.addressDetail;
      },

      getData() {
        this.$http.get("basic", `sd/DeliveryBills/${this.pkid}`).then(res => {
          if (res.success) {
            this.deliveryNotice = res.data;
            // this.getSalesOrderDetail();
          }
        });
      },

      addMaterial() {
        if (this.selectedMaterial) {
          let material = this.materials.filter(item => item.materialId === this.selectedMaterial);
          let array = this.deliveryNotice.deliveryBillDetails.filter(item => item.materialId === this.selectedMaterial);
          if (array.length === 0) {
            this.deliveryNotice.deliveryBillDetails.push(material[0]);
          }
          this.getSalesOrderDetail();
        }

      },

      quantityChange(row, value, index) {
        const reg = /^[1-9]\d*$/;
        if (!reg.test(value)) {
          this.$confirm("请输入大于0的整数", "错误", {
            type: "error",
            showCancelButton: false,
          });
          this.deliveryNotice.deliveryBillDetails[index].quantity = 0;
          return;
        }
        if (value > row.salesOrderQuantity - row.shippedQuantity) {
          this.$confirm("物料：" + row.materialNo + " 发货数量超出订单剩余数量", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.deliveryNotice.deliveryBillDetails[index].quantity = value;
      },

      salesOrderDetailSelect(rows) {
        if (rows) {
          // let isSame = true;
          // //验证是否同一个客户
          // rows.forEach(item => {
          //   if (item.customerId !== rows[0].customerId) {
          //     isSame = false;
          //   }
          // });
          // if (!isSame) {
          //   this.$confirm("请选择相同客户订单", "错误", {
          //     type: "error",
          //     showCancelButton: false,
          //   });
          //   return;
          // }
          let customerId = rows[0].customerId;
          let result = rows.some((item) => item.customerId !== customerId);
          if (result) {
            this.$confirm("请选择相同客户的订单", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          if (!this.deliveryNotice.customerId) {
            this.deliveryNotice.customerId = rows[0].customerId;
            this.deliveryNotice.customerName = rows[0].customerName;
            this.deliveryNotice.finalCustomerName = rows[0].finalCustomerName;
            //默认地址
            this.$http.get("basic", `customerDeliveryAddress/isDefault/${this.deliveryNotice.customerId}`).then(res => {
              if (res.success) {
                this.deliveryNotice.deliveryTel = res.data.telephone;
                this.deliveryNotice.deliveryContact = res.data.contact;
                this.deliveryNotice.deliveryAddress = res.data.addressDetail;
              }
            });
          } else {
            if (this.deliveryNotice.customerId !== rows[0].customerId) {
              this.$confirm("请选择相同客户订单", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
          }
          // this.deliveryNotice.salesOrderNo = rows[0].salesOrderNo;
          this.deliveryNotice.deliveryDate = rows[0].confirmDeliveryDate;
          // this.getSalesOrderInfo(row.salesOrderId);
          rows.forEach(item => {
            console.log(item);
            if (item.customerId !== this.deliveryNotice.customerId) {
              this.$confirm("请选择相同客户订单", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            const material = {
              salesOrderNO: item.salesOrderNo,
              salesOrderRowIndex: item.rowIndex,
              unit: item.unitName,
              salesOrderQuantity: item.quantity,
              shippedQuantity: item.shippedQuantity,
              quantity: item.quantity - item.commitQuantity,
              price: item.price,
              materialId: item.materialId,
              materialNo: item.materialNo,
              materialName: item.materialName,
              specification: item.materialSpecification,
              requireDeliveryDate: item.confirmDeliveryDate,
              erpSourceBillNo: item.erpSalesOrderNo,
              erpSourceInterId: item.erpSalesOrderId,
              erpSourceEntryId: item.rowIndex,
              note: item.deliveryNote,
              customerSpecification: item.customerSpecification,
              orderRowNote: item.note,
            };

            var findIt = false;
            this.deliveryNotice.deliveryBillDetails.forEach(s => {
              if (s.salesOrderNO == item.salesOrderNo && s.salesOrderRowIndex == item.rowIndex) {
                findIt = true;
              }
            });
            if (findIt == false) {
              this.materialOptions.push(material);
              this.deliveryNotice.deliveryBillDetails.push(material);
            }
          });
        }
        // this.deliveryNotice.salesOrderNo = row.salesOrderNo;
        // this.deliveryNotice.customerName = row.customerName;
        // this.deliveryNotice.customerId = row.customerId;
        // this.deliveryNotice.deliveryDate = row.deliveryDate;
        // this.getSalesOrderInfo(row.salesOrderId);
      },

      getSalesOrderDetail() {
        this.$http.post("basic", "sd/DeliveryBills/selectSalesOrderDetails", this.deliveryNotice).then(res => {
          if (res.success) {
            res.data.forEach(item => {
              item.salesOrderRowIndex = item.rowIndex;
              item.unit = item.unitName;
              item.salesOrderQuantity = item.quantity;
              item.quantity = item.quantity - item.shippedQuantity;
            });
            this.materialOptions = res.data;
          }
        });
      },

      getSalesOrderInfo(salesOrderId) {
        this.$http.get("basic", `sd/so/${salesOrderId}`).then(res => {
          if (res.success) {
            this.deliveryNotice.deliveryBillDetails = res.data.materialVOS.filter(item => item.quantity !== item.shippedQuantity);
            this.deliveryNotice.deliveryBillDetails.forEach(item => {
              item.salesOrderRowIndex = item.rowIndex;
              item.unit = item.unitName;
              item.salesOrderQuantity = item.quantity;
              item.quantity = item.quantity - item.shippedQuantity;
            });
          }
        });
      },

      deleteRow(row, index) {
        this.materialOptions.push(row);
        this.deliveryNotice.deliveryBillDetails.splice(index, 1);
        this.getSalesOrderDetail();
      },

      closePage() {
        this.dialogVisible = false;
      },

      selectFocus() {
        this.materials = this.materialOptions;
      },

      handleSubmit() {
        var sum = 0;
        var quantityCheck = true;
        this.deliveryNotice.deliveryBillDetails.forEach((item) => {
          if (item.quantity > item.salesOrderQuantity - item.shippedQuantity) {
            this.$confirm("规格型号：" + item.materialSpecification + " 发货数量超出订单剩余数量", "错误", {
              type: "error",
              showCancelButton: false,
            });
            this.quantityCheck = false;
            return;
          }
          sum += item.quantity * item.price;
        });
        this.deliveryNotice.totalAmount = sum;
        if (quantityCheck) {
          this.$http.post("basic", "sd/DeliveryBills/save", this.deliveryNotice).then(res => {
            if (res.success) {
              this.$message.success("保存成功");
              this.$emit("save-success");
              this.dialogVisible = false;
            }
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>